import React from 'react';

const ChildComponent = ({ message }) => {
  return <p>Child says: {message}</p>;
};

export default ChildComponent;
